import React, { Fragment } from "react";
import GroupBarchart from "../../../../../d3Components/NewBarchart/GroupBarchart";
import Spinner from "../../../Datatable/spinner/spinner";
import Legend from "../../../../../d3Components/legend";
import SimpleTable from "../../../common/simpleTable";

const AnnualizedBacktest = (props) => {
  const { data, typeName, benchmark_name, initialWidth } = props;
  const newArray = [];

  for (let i in data) {
    let line = data[i];

    let fd = parseFloat((parseFloat(line.fund_return) * 100).toFixed(2));
    let bm = parseFloat((parseFloat(line.bm_return) * 100).toFixed(2));
    switch (line.metric_name) {
      case "1 Year":
        if (newArray.indexOf("1 Year") === -1)
          newArray.push({
            metric_name: "1 Year",
            portfolio: fd,
            benchmark: bm,
          });
        break;
      case "3 Year":
        if (newArray.indexOf("3 Year") === -1)
          newArray.push({
            metric_name: "3 Year",
            portfolio: fd,
            benchmark: bm,
          });
        break;
      case "5 Year":
        if (newArray.indexOf("5 Year") === -1)
          newArray.push({
            metric_name: "5 Year",
            portfolio: fd,
            benchmark: bm,
          });
        break;
      case "Since Inception":
        if (newArray.indexOf("Since Inception") === -1)
          newArray.push({
            metric_name: "Since Inception",
            portfolio: fd,
            benchmark: bm,
          });
        break;
      default:
    }
  }
  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <h4 className="text-uppercase bold">
        ANNUALIZED BACK-TESTED PERFORMANCE
      </h4>
      {props.spinner ? (
        <Spinner />
      ) : (
        <Fragment>
          {newArray.length > 0 ? (
            <Fragment>
              <div style={{ overflowX: "auto" }}>
                <Legend height={30} width={500} legend2={typeName} />
                <GroupBarchart
                  width={initialWidth}
                  height={300}
                  data={newArray}
                  targetDiv="backtestBarChart5"
                />
              </div>
              {benchmark_name ? (
                <div>
                  <small>
                    <b>*</b>&nbsp;{benchmark_name}
                  </small>
                </div>
              ) : null}
            </Fragment>
          ) : null}
          <SimpleTable
            rowHead1={"Portfolio"}
            rowHead2={"Benchmark"}
            heading={newArray.map((d, i) => {
              return <td key={i}>{d.metric_name}</td>;
            })}
            Row1={newArray.map((d, i) => {
              return <td key={i}>{`${d.portfolio.toFixed(2)} %`}</td>;
            })}
            Row2={newArray.map((d, i) => {
              return <td key={i}>{`${d.benchmark.toFixed(2)} %`}</td>;
            })}
          />
        </Fragment>
      )}
    </div>
  );
};

export default AnnualizedBacktest;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/backtest/growth/section1/annualizedBacktest.jsx